<template>
    <div class="position-relative">
        <multiselect
            :id="id"
            :loading="isLoading"
            v-model="position"
            tag-placeholder=""
            placeholder=""
            :options="position_select"
            :close-on-select="true"
            :clear-on-select="false"
            label="title" track-by="id"
            :taggable="true"
            :selectedLabel="''"
            :placeholder="''"
            :selectLabel="''"
            :deselectLabel="''"
            :tagPlaceholder="''"
            :showNoOptions="false"
            :searchable="true"
            :disabled="disabled"
            group-values="items"
            group-label="group_name"
        >
            <template slot="option" slot-scope="props">
                <span v-if="props.option.label" class="option__title">{{props.option.label}}</span>
                <span v-if="props.option.$groupLabel" class="option__title">{{props.option.$groupLabel}}</span>
                <span v-if="props.option.title" class="option__title">{{ props.option.title }}</span>

                <a v-if="props.option.id && $hasPermission('positions.update')" @click="showEdit(props.option.id)" class="small text-muted">{{props.option.$groupLabel}} редактировать</a>
            </template>
            <template slot="beforeList" v-if="$hasPermission('positions.create')">
                <li class="multiselect__element"><span class="multiselect__option"><a @click="showCreate()" class="option__title">Добавить</a></span></li>
            </template>
        </multiselect>
        <div v-if="position" class="clear-all-filter" @click="position = null" style="right: 40px;top: 9px;"><XIcon /></div>
        <el-dialog :title="form_mode === 'create' ? 'Добавление должности' : 'Редактирование должности'" :visible.sync="form_state" width="450px" :append-to-body="true">
            <PositionForm v-if="form_state" :mode="form_mode" :obj="form_obj" @created="onCreated" @updated="onUpdated"/>
        </el-dialog>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import PlatformHelper from "../../helpers/platform";
import CarForm from "../cars/CarForm";
import PositionForm from "./PositionForm";
import {XIcon} from "vue-feather-icons";

export default {
    name: "PositionSelect",
    components: {PositionForm, CarForm, Multiselect, XIcon},
    props: ['value', 'id', 'search', 'disabled', 'allowed_create', 'platform_ids'],
    data: () => ({
        position: null,
        positions: [],

        form_state: false,
        form_mode: null,
        form_obj: null,
        isLoading: false,
    }),
    mounted() {
        let self = this;

        this.fetch();
    },
    watch: {
        position(val) {
            this.$emit('input', val ? val.id : null);
        },
        value(val) {
            let self = this;
            let i = setInterval(() => {
                if (self.isLoading === false) {
                    clearInterval(i);
                    self.position_select.forEach(group => {
                        group.items.forEach(item => {
                            if (+item.id === +val) self.position = item;
                        })
                    })
                }
            }, 1000)
        }
    },
    computed: {
        position_select() {
            let data = {};
            let self = this;
            this.positions.forEach(function (item) {
                if (self.platform_ids && self.platform_ids.length) {
                    if (!self.platform_ids.includes(item.platform_id)) return;
                }
                if (!data[item.platform_id]) data[item.platform_id] = {group_name: PlatformHelper.get(item.platform_id).name, items: []}

                data[item.platform_id].items.push({
                    id: item.id,
                    title: item.name,
                });
            });
            data = _.mapValues(data, function (item) {
                item.items = _.sortBy(item.items, ['title'])
                return item;
            });
            return _.values(data);
        }
    },
    methods: {
        fetch() {
            let self = this;
            this.isLoading = true;
            let params = _.clone(this.search ? this.search : {});
            axios.get('/api/positions', {params})
                .then(response => {
                    self.positions = response.data;
                    self.isLoading = false;

                    self.position_select.forEach(group => {
                        group.items.forEach(item => {
                            if (+item.id === +self.value) self.position = item;
                        })
                    })
                });
        },
        showCreate() {
            this.form_mode = 'create';
            this.form_state = true;
            this.form_obj = null;
        },
        showEdit(id) {
            this.form_mode = 'edit';
            this.form_obj = _.find(this.positions, {id: id});
            this.form_state = true;

            let self = this;
            this.position_select.forEach(group => {
                group.items.forEach(item => {
                    if (item.id === id) self.position = item;
                })
            })
        },
        onUpdated(position) {
            let self = this;
            this.form_state = false;
            console.log(position);
            this.positions = this.positions.map(item => {
                if (item.id === position.id) item = position;
                return item;
            })
            this.position_select.forEach(group => {
                group.items.forEach(item => {
                    if (item.id === position.id) self.position = item;
                })
            })
        },
        onCreated(position) {
            let self = this;
            this.positions.push(position);
            this.form_state = false;
            this.position_select.forEach(group => {
                group.items.forEach(item => {
                    if (item.id === position.id) self.position = item;
                })
            })
        },
    }
}
</script>

<style scoped>

</style>
